import gql from "graphql-tag";

// fragment
export const COLOR_FRAGMENT = gql`
    fragment color on ColorNode {
        id
        color
        updatedAt
        updatedBy
    }
`;

// all query
export const COLORS_QUERY = gql`
    query {
        tenantColors {
            edges {
                node {
                    ...color
                }
            }
        }
    }
    ${COLOR_FRAGMENT}
`;

// single query
export const SINGLE_COLOR_QUERY = gql`
    query color($id: ID!) {
        color(id: $id) {
            ...color
        }
    }
    ${COLOR_FRAGMENT}
`;

// create
export const CREATE_COLOR_MUTATION = gql`
    mutation createColor($input: CreateColorInput!) {
        createColor(input: $input) {
            color {
                ...color
            }
        }
    }
    ${COLOR_FRAGMENT}
`;

// update
export const UPDATE_COLOR_MUTATION = gql`
    mutation updateColor($input: UpdateColorInput!) {
        updateColor(input: $input) {
            color {
                ...color
            }
        }
    }
    ${COLOR_FRAGMENT}
`;

// delete
export const DELETE_COLOR_MUTATION = gql`
    mutation deleteColor($input: DeleteColorInput!) {
        deleteColor(input: $input) {
            color {
                ...color
            }
        }
    }
    ${COLOR_FRAGMENT}
`;
